import { z } from 'zod';
export const createEventSchema = z.object({
    org_id: z.string().uuid(),
    event_type: z.string().min(1).max(50),
    payload: z.object({
        version: z.string(),
    }).passthrough(),
});
export const leadCreatedPayloadSchema = z.object({
    version: z.literal('1.0'),
    lead_id: z.string().uuid(),
    org_id: z.string().uuid(),
    location_id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    phone: z.string().nullable(),
    source_page: z.string(),
    crm_tags: z.array(z.string()),
    utm_source: z.string().nullable(),
    utm_medium: z.string().nullable(),
    utm_campaign: z.string().nullable(),
    created_at: z.string().datetime(),
});
//# sourceMappingURL=event.js.map